import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import { useMediaQuery, ButtonBase } from '@mui/material';
import {EmailShareButton, EmailIcon, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon} from "react-share";
import RespImg from '../../ui/RespImg';
import Link from '../NextLink';
import HeartIcon from '../../../assets/icons/new-heart-white.svg';
import HeartFilledIcon from '../../../assets/icons/new-heart-white-filled.svg';
import DownloadIcon from '../../../assets/icons/download-white.svg';
import { ReactSVG } from 'react-svg';
import NavArrowDown from '../../../assets/icons/new_nav_arrow_down.svg';
import NavClose from '../../../assets/icons/new_nav_close.svg';
import Topo from '../../../assets/topo-block-blue.png';
import Modal from '../../ui/Modal';
import SharePopup from '../../ui/SharePopup';
import { useRouter } from 'next/router';

const downSm = '@media (max-width: 939.95px)' // '@media (max-width: 839.95px)'
const upMd = '@media (min-width: 940px)' // '@media (min-width: 840px)'

const Wrapper = styled.div`
    ${props => props.background && `
        background: ${props.background};
        * {
            color: ${theme.palette.white};
        }
    `}
    position: absolute;
    top: 71px;
    left: 0;
    width: 100%;
    z-index: 5;
    
    ${upMd} {
        top: 87px;
    }

    ${downSm} {
        ${props => (!props.dealer && props.hasBreadcrumbs == 1 && props.breadcrumbsHeight) ? `
            top: ${71 + props.breadcrumbsHeight}px;
            `: !props.dealer && !props.hasBreadcrumbs && !props.breadcrumbsHeight &&`
            top: 71px;
        `}
        ${props => (props.dealer == 1 && props.hasBreadcrumbs == 1 && props.breadcrumbsHeight) ? `
            top: ${63 + props.breadcrumbsHeight}px;
            `: (!props.dealer && !props.hasBreadcrumbs && !props.breadcrumbsHeight) &&`
            top: 63px;
        `}
        ${props => props.active && `
            position: fixed;
            left: 0;
            width: 100%;
            height: 100%;
        `}
    }

    ${props => props.isTop == 1 && `
        top: 0 !important;
        position: fixed;
    `}
    ${props => props.scrollTop == 1 && `
        transition: top 800ms ease-in-out;
        ${upMd} {
            top: 87px !important;
        }
        position: fixed;
    
    `}
    ${props => (props.scrollTop == 1) && (props.dealer == 1) && `
        ${downSm} {
            top: 63px !important;
        }
    `}
    ${props => (props.scrollTop == 1) && (!props.dealer) && `
        ${downSm} {
            top: 71px !important;
        }
    `}
`

const Container = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    ${theme.breakpoints.up('md')} {
        padding: 0 40px;
    }
`

const SubNavTopContainer = styled.div`
    padding: 16px 0;
    position: relative;
    overflor: auto;
    a {
        text-decoration: none;
    }
    ${theme.breakpoints.up('md')} {
        max-width: 1400px;
        margin: auto;
        display: flex;
        gap: 15px;
        align-items: center;
        justify-content: space-between;
    }
    ${theme.breakpoints.up('lg')} {
        gap: 20px;
    }
`
const LogoContainer = styled.div`
    ${theme.breakpoints.up('md')} {
        img {
            width: 170px;
        }
    }
    ${theme.breakpoints.down('sm')} {
        display: inline-block;
        img {
            width: 114px;
        }
    }
`

const SubNavLinksWrapper = styled.div`
    ${theme.breakpoints.up('md')} {
        margin: auto;
    }
    ${theme.breakpoints.down('sm')} {
        position: absolute;
        visibility: hidden;
        opacity: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        ${props => props.active && `
            height: 100%;
            width: 100%;
            position: fixed;
            visibility: visible;
            opacity: 1;
            overflow-y: auto;
        `}
        ${props => props.background && `
            background: ${props.background};
        `}
    }
`

const SubNavLinks = styled.div`
    ${theme.breakpoints.up('md')} {
        display: flex;
        align-items: center;
        gap: 15px;
    }
    ${theme.breakpoints.up('lg')} {
        gap: 45px;
    }
    ${theme.breakpoints.down('sm')} {
        padding: 0 20px;
    }
`
const NavItem = styled(ButtonBase)`
    ${theme.breakpoints.up('md')} {
        a {
            font-weight: 700;
            font-size: 12px;
            line-height: 19px;
            text-align: center;
            letter-spacing: 1px;
            text-transform: uppercase;
        }
    }
    ${theme.breakpoints.up('lg')} {
        a {
            font-size: 14px;
        }
    }
    ${theme.breakpoints.down('sm')} {
        display: block;
        margin-bottom: 45px;
        margin-left: auto;
        margin-right: auto;
        a {
            font-weight: 700;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 1px;
            text-transform: uppercase;
            color: #FFFFFF;
        }
    }
`

const SubNavLogos = styled.div`

    svg {
        cursor: pointer;
        width: 22px;
        height: 21px;
    }

    ${theme.breakpoints.up('md')} {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-right: 20px;
    }
    ${theme.breakpoints.up('md')} {
        gap: 30px;
        margin-right: 35px;
    }
`

const LogoSvg = styled(ReactSVG)`
    svg {
        vertical-align: middle;
    }
`
const IconSvg = styled(ReactSVG)`
    position: relative;
    top: -1px;
    svg {
        vertical-align: middle;
    }
`

const NavToggleItem = styled.div`
    cursor: pointer;
`

const MobileToggleLink = styled.div`
    float: right;
    right: 0;
    > div  {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    a {
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
    }
    svg {
        filter: brightness(0) invert(1);
    }
    ${props => !props.active ? ` 
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        svg {
           height: 13px;
           width: 13px;
        }
    `: `
        position: relative;
        z-index: 3;
        height: 16px;
        svg {
            height: 6px;
            height: 11px;
        }
    `}
`

const newSubNavDefaultPropNav = [];
const newSubNavDefaultPropImage = {};
const newSubNavDefaultPropOnSave = () => {};

const NewSubNav = (props) => {
    props = {
        ...props,
        bgColour: typeof props.bgColour === "undefined" ? null : props.bgColour,
        nav: typeof props.nav === "undefined" ? newSubNavDefaultPropNav : props.nav,
        image: typeof props.image === "undefined" ? newSubNavDefaultPropImage : props.image,
        onSave: typeof props.onSave === "undefined" ? newSubNavDefaultPropOnSave : props.onSave,
        saved: typeof props.saved === "undefined" ? false : props.saved
    };

    const {
        bgColour,
        nav,
        image,
        onSave,
        saved,
    } = props;

    // States Start
    const [mobileToggle, setMobileToggle] = useState(false);
    const [isTop, setIsTop] = useState(false);
    const [scrollTop, setScrollTop] = useState(false);
    const [modal, setModal] = useState(false);
    const [activeItem, setActiveItem] = useState(nav[0]);
    const router = useRouter();
    // States End

    console.log('newsubnav items activeItem', activeItem);

    // Methods Start
    const handleMobileToggle = () => {
        setMobileToggle(!mobileToggle);
    }
    // Methods End

    // Effect Start

    // Effect End

    // Media Breakpoint Start
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End
    const getStyle = (oElm, strCssRule) => {
        var strValue = "";
        if(document.defaultView && document.defaultView.getComputedStyle){
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if(oElm.currentStyle){
            strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    const handleClick = (e, item) => {
        setMobileToggle(false);
        setActiveItem(item);
        if (item.href.indexOf('#') !== -1) {
            e.preventDefault();
            const id = item.href.split('#')[1].replace('#');
            const element = document.getElementById(id);
            if (element) {
                const topPos = element.getBoundingClientRect().top + window.pageYOffset;
                const cssTopPadding = getStyle(element, 'padding-top');
                const cssTopMargin = getStyle(element, 'margin-top');
                
                const topPadding = cssTopPadding.length > 0 ? parseInt(cssTopPadding) : 0
                const topMargin = topPadding > 0 ? 0 : (cssTopMargin.length > 0 ? parseInt(cssTopMargin) : 0)

                const isMobile = window.outerWidth < 940
                const heightOfNav = 0 // isMobile ? 71 : 87 // not needed now
                const heightOfSubNav = isMobile ? 48.5 : 53

                window.scrollTo({
                    top: topPos - heightOfNav - heightOfSubNav - topMargin, // scroll so that the element is at the top of the view
                    behavior: 'smooth' // smooth scroll
                })
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // smooth scroll
                })
            }
        }
    }

    useEffect(() => {
        if (router && router.asPath) {
            var lastScrollTop = 0;
            const handleScroll = (e) => {
                const isMobile = window.outerWidth < 940
                const heightOfNav = isMobile && process.env.DEALER_SITE !== true ? 71 : isMobile && process.env.DEALER_SITE == true ? 63 : 87 // not needed now
                
                var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
                
        
                if (scrollTop > lastScrollTop && scrollTop > heightOfNav) {
                    setIsTop(true);
                    setScrollTop(false);

                }  else if (scrollTop < lastScrollTop && scrollTop > heightOfNav) {
                    setScrollTop(true);
                    setIsTop(false);
                } else {
                    setIsTop(false);
                    setScrollTop(false);
                }

                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling

            }
            document.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }
    },[router && router.asPath])

    useEffect(() => {
        if (props.activeScrollItem) {
            const _activeItem = nav.find(item => item.title === props.activeScrollItem.anchorId);
            console.log('activeScrollItem', _activeItem);
            if (_activeItem) {
                setActiveItem(_activeItem);
            } else {
                // setActiveItem({});
            }
        }
    },[props.activeScrollItem])

    return (
        <>
            <Modal
                isOpen={modal}
                onClose={() => setModal(false)}
                iconVividBlue={true}
                innerClassname={'share-container'}
                thickCloseIcon={true}
            >
                <SharePopup onShareClick={props.onShareClick} />
            </Modal>
            <Wrapper dealer={process.env.DEALER_SITE !== true ? 0 : 1} isTop={isTop ? 1 : 0} scrollTop={scrollTop ? 1 : 0} background={bgColour ? bgColour : ''} active={(mobileToggle && mobileView) ? 1 : 0} hasBreadcrumbs={props.hasBreadcrumbs ? 1 : 0} breadcrumbsHeight={props.breadcrumbsHeight ? props.breadcrumbsHeight : 0}>
                <Container>
                    <SubNavTopContainer>
                        {image &&
                            <LogoContainer>
                                <RespImg
                                    {...image}
                                    type="png"
                                />
                            </LogoContainer>
                        }
                        {mobileView &&
                            <MobileToggleLink active={(mobileToggle && mobileView) ? 1 : 0}>
                                <NavToggleItem onClick={handleMobileToggle}>
                                    {!mobileToggle ?
                                        <>
                                            
                                                {activeItem.title}
                                           
                                            <IconSvg src={NavArrowDown} />
                                        </>
                                        :
                                        <>
                                            
                                                Close
                                            
                                            <IconSvg src={NavClose} />
                                        </>
                                    }
                                </NavToggleItem>
                            </MobileToggleLink>
                        }
                        {((desktopView) || (mobileToggle && mobileView)) &&
                            <SubNavLinksWrapper active={(mobileToggle && mobileView) ? 1 : 0} background={bgColour ? bgColour : ''}>
                                <SubNavLinks>
                                    {nav && nav.length > 0 &&
                                        nav.map((item, index) => {
                                            return (
                                                <NavItem key={item.id ? item.id : index}>
                                                    <Link legacyBehavior key={item.id ? item.id : index} href={item.href && item.href} target={item.target && item.target}>
                                                        <a onClick={(e) => handleClick(e, item)}>
                                                            {item.title}
                                                        </a>
                                                    </Link>
                                                </NavItem>
                                            )
                                        })

                                    }
                                </SubNavLinks>
                            </SubNavLinksWrapper>
                        }
                        {desktopView &&
                            <SubNavLogos>
                                <LogoSvg src={saved ? HeartFilledIcon : HeartIcon} onClick={onSave}/>
                                <LogoSvg src={DownloadIcon} onClick={() => setModal(true)}/>
                            </SubNavLogos>
                        }
                    </SubNavTopContainer>
                </Container>
            </Wrapper>
        </>
    )
}

NewSubNav.propTypes = {
    bgColour: propTypes.string,
    nav: propTypes.array,
    image: propTypes.object,
    onSave: propTypes.func,
    saved: propTypes.bool
}

export default NewSubNav